import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { primaryColor, whiteColor } from "../../../assets/jss/material-kit-pro-react";
import makeStyles from "@mui/styles/makeStyles";
import AddPhotoAlternateOutlined from "@mui/icons-material/AddPhotoAlternateOutlined";
import CropImageModal from "../CropImageModal";

const MAX_UPLOAD_SIZE = 500 * 1024; // 500 KB

// Preview box: 3:1 landscape ratio
const PREVIEW_WIDTH = 300;
const PREVIEW_HEIGHT = 100;

const styles = () => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
    },
    imgWrapper: {
        display: "flex",
        position: "relative",
        width: PREVIEW_WIDTH,
        height: PREVIEW_HEIGHT,
        backgroundColor: "#f5f5f5",
        border: "1px solid #ddd",
        borderRadius: 4,
        cursor: "pointer",
    },
    imgOverlay: {
        display: "flex",
        justifyContent: "center",
        width: PREVIEW_WIDTH,
        height: PREVIEW_HEIGHT,
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        color: whiteColor,
        fontSize: 12,
        fontWeight: 400,
        textTransform: "uppercase",
        cursor: "pointer",

        "&:hover": {
            backgroundColor: primaryColor[0],
            opacity: 0.9,
            cursor: "pointer",

            "& > span": {
                visibility: "visible !important",
                color: whiteColor,
                alignSelf: "center",
                fontSize: "small",
                textAlign: "center",
                padding: "0 8px",
            },
            "& > svg": {
                visibility: "visible !important",
            },
        },
    },
    imgOverlayTxt: {
        visibility: "hidden",
    },
    imageIconOverlay: {
        fontSize: 24,
        color: whiteColor,
        position: "absolute",
        top: 4,
        left: 4,
        visibility: "hidden",
    },
    img: {
        width: PREVIEW_WIDTH,
        height: PREVIEW_HEIGHT,
        objectFit: "contain",
        backgroundColor: "white",
    },
    hint: {
        fontSize: 11,
        color: "#888",
    },
    errorMessage: {
        color: "red",
        fontWeight: 600,
        fontSize: 12,
    },
});

const useStyles = makeStyles(styles);

const SponsorImageSelectAdapter = ({ input, logoPath }) => {
    const classes = useStyles();
    const [image, setImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [cropModalOpen, setCropModalOpen] = useState(false);

    useEffect(() => {
        if (logoPath) setImage(logoPath);
    }, [logoPath]);

    const handleSelectImage = (file) => {
        if (!file) return;

        const fileType = file.type.split("/")[0];
        if (fileType !== "image") return;

        if (file.size > MAX_UPLOAD_SIZE) {
            setErrorMessage(`Das Logo darf maximal ${MAX_UPLOAD_SIZE / 1024} KB groß sein.`);
            return;
        }

        input.onChange(file);
        setImage(URL.createObjectURL(file));
        setCropModalOpen(false);
        setErrorMessage(null);
    };

    return (
        <div className={classes.wrapper}>
            <CropImageModal
                open={cropModalOpen}
                handleClose={() => setCropModalOpen(false)}
                handleSelectImage={handleSelectImage}
                rectangular
                initialAspect={3}
                maxSize={MAX_UPLOAD_SIZE}
            />
            <div className={classes.imgWrapper}>
                <div className={classes.imgOverlay} onClick={() => setCropModalOpen(true)}>
                    <AddPhotoAlternateOutlined className={classes.imageIconOverlay} />
                    <span className={classes.imgOverlayTxt}>SPONSOR-LOGO ÄNDERN</span>
                </div>
                <img
                    src={image || undefined}
                    alt="Sponsor-Logo"
                    className={classes.img}
                    style={!image ? { opacity: 0 } : undefined}
                />
            </div>
            <span className={classes.hint}>
                Empfohlen: 600×200 px (Querformat 3:1), max. 500 KB, PNG oder JPG
            </span>
            {errorMessage && (
                <div className={classes.errorMessage}>{errorMessage}</div>
            )}
        </div>
    );
};

SponsorImageSelectAdapter.propTypes = {
    input: PropTypes.object,
    logoPath: PropTypes.string,
};

export default SponsorImageSelectAdapter;
